import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { Component, OnInit , NO_ERRORS_SCHEMA, OnDestroy } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-create-account-type-selection',
  templateUrl: './create-account-type-selection.component.html',
})
export class CreateAccountTypeSelectionComponent implements OnInit, OnDestroy {
  isAcmic = false;

  constructor(
    private location: Location,
    private router: Router,
    private isAcmicService: AcmicService,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
    this.isAcmic = this.isAcmicService.isACMIC();
  }

  goBack(): void {
    this.location.back();
  }
  openCommercialAccount(): void {
    this.router.navigate(['/signup', 'create-commercial-account']);
  }
  openSignup(): void {
    this.router.navigate(['/signup']);
  }

   ngOnDestroy() {
    this.meta.removeTag('name="robots"');
  }
}
